
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class JournalDetailGrid extends Serenity.EntityGrid<JournalDetailRow, any> {
        protected getColumnsKey() { return 'Finance.JournalDetail'; }
        protected getDialogType() { return JournalDetailDialog; }
        protected getIdProperty() { return JournalDetailRow.idProperty; }
        protected getInsertPermission() { return JournalDetailRow.insertPermission; }
        protected getLocalTextPrefix() { return JournalDetailRow.localTextPrefix; }
        protected getService() { return JournalDetailService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}